import React from 'react';

/**
 * MessageTeamButton — the floating mobile entry point to the conversation rail
 * (Epic 7 · S7.5).
 *
 * Visible only below `lg` (the rail itself is a permanent sidebar on `lg+`).
 * A floating button bottom-right with an unread badge; clicking opens the
 * conversation sheet (owned by PortalPage, which passes `onClick`).
 *
 * The unread count comes from the conversation panel facts (`facts.unread`).
 * Zero unread still shows the button (the user can open the thread) but
 * suppresses the badge.
 */
const MessageTeamButton = ({ unread, onClick, className = '' }) => {
  const count = typeof unread === 'number' ? unread : 0;
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={count > 0 ? `Open conversation, ${count} unread` : 'Open conversation'}
      data-testid="message-team-button"
      className={`lg:hidden fixed bottom-4 right-4 z-30 inline-flex items-center justify-center w-14 h-14 rounded-full shadow-lg bg-[#32B1FF] text-white hover:bg-[#1aa3f5] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#32B1FF] focus-visible:ring-offset-2 ${className}`}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
      {count > 0 && (
        <span
          className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1.5 inline-flex items-center justify-center text-xs font-semibold text-white bg-red-500 rounded-full"
          data-testid="unread-badge"
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
};

export default MessageTeamButton;
